<template>
  <div>
    <v-menu
      offset-y
      :close-on-content-click="false"
      v-model="datePickerOpen"
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          outlined
          dense
          readonly
          v-on="on"
          :label="$t('common.date.date')"
          :value="formattedDate"
          :disabled="loading"
          :rules="rules"
          prepend-inner-icon="mdi-calendar"
          @click:clear="clearDate"
          clearable
        />
      </template>
      <v-date-picker
        v-model="dateValue"
        no-title
        @input="onDateChange"
      />
    </v-menu>

    <v-menu
      v-if="includeTime"
      offset-y
      :close-on-content-click="false"
      v-model="timePickerOpen"
      max-width="290px"
      min-width="290px"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          outlined
          dense
          readonly
          v-on="on"
          class="mt-3"
          :label="$t('magnitudes.time')"
          :value="timeValue"
          :disabled="loading"
          prepend-inner-icon="mdi-clock-outline"
        />
      </template>
      <v-time-picker
        v-model="timeValue"
        format="24hr"
        @input="onTimeChange"
      />
    </v-menu>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'DateForm',

  props: {
    response: {
      required: false,
      default: null,
    },
    loading: Boolean,
    rules: {
      type: Array,
      default: () => [],
    },
    includeTime: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      datePickerOpen: false,
      timePickerOpen: false,
      dateValue: null,
      timeValue: null,
    }
  },

  watch: {
    response: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          const m = moment(newValue)
          if (m.isValid()) {
            this.dateValue = m.format('YYYY-MM-DD')
            if (this.includeTime) {
              this.timeValue = m.format('HH:mm')
            }
          }
        } else {
          this.dateValue = null
          if (this.includeTime) {
            this.timeValue = null
          }
        }
      },
    },
  },

  computed: {
    formattedDate() {
      if (!this.dateValue) return ''
      const m = moment(this.dateValue)
      if (!m.isValid()) return ''
      return m.format('LL')
    },
  },

  methods: {
    onDateChange(date) {
      this.datePickerOpen = false
      this.dateValue = date
      this.emitChange()
    },

    onTimeChange(time) {
      this.timePickerOpen = false
      this.timeValue = time
      this.emitChange()
    },

    emitChange() {
      if (!this.dateValue) {
        this.$emit('change', null)
        return
      }

      let dateTime
      if (this.includeTime) {
        // If includeTime is true, default to '00:00' if no time is set
        const time = this.timeValue || '00:00'
        dateTime = moment(`${this.dateValue} ${time}`, 'YYYY-MM-DD HH:mm')
      } else {
        dateTime = moment(this.dateValue, 'YYYY-MM-DD')
      }

      this.$emit('change', dateTime.toISOString())
    },

    clearDate() {
      this.dateValue = null
      if (this.includeTime) {
        this.timeValue = null
      }
      this.$emit('change', null)
    },
  },
}
</script>
